import React, { useState, useRef, useEffect } from "react";
import Popover from "../popover";
import ChevronDownIcon from "../../icons/chevronDownIcon";
import styles from "./style.module.css";

const SelectInput = (props) => {
  const { value, options, placeholder, isFormField = true, onChange } = props;
  const optionsList = options?.options;
  const customClass = options?.customClass;
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(value ? JSON.parse(value) : null);
  const buttonRef = useRef(null);
  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelect = (option) => {
    setSelected(option);
    setOpen(false);
    if (isFormField) {
      onChange(JSON.stringify(option));
    } else {
      onChange(option);
    }
  };

  useEffect(() => {
    if (value) {
      setSelected(JSON.parse(value));
    }
  }, [value]);

  return (
    <div className={`${styles.selectInput} ${customClass}`}>
      <button
        type="button"
        className={`${styles.selectInput_btn} ${
          open ? styles.selectInput_btn_open : ""
        }`}
        ref={buttonRef}
        onClick={handleToggle}
      >
        <span className={styles.selectInput_btn_text}>
          {selected && selected?.label ? selected?.label : placeholder}
        </span>
        <ChevronDownIcon className={styles.selectInput_btn_icon} />
      </button>
      <Popover open={open} buttonRef={buttonRef} onClose={handleClose}>
        <div className={styles.selectInput_options}>
          {optionsList &&
            optionsList.map((option) => (
              <button
                type="button"
                key={option.value}
                value={option.value}
                className={`${styles.selectInput_option} ${
                  selected?.value === option.value ? styles.selected : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </button>
            ))}
        </div>
      </Popover>
    </div>
  );
};

export default SelectInput;
